import { put, takeLatest, delay } from 'redux-saga/effects'

import { FETCH_APPDATA_FAILED, FETCH_APPDATA_REQUESTING, FETCH_APPDATA_SUCCESSED } from '../actions/actionTypes'

function* fetchAppData() {
  try {
    yield delay(3 * 1000)
    yield put({
      type: FETCH_APPDATA_SUCCESSED,
      data: [{ id: 1, name: "Jason" }, { id: 2, name: "Smith" }]
    })
  } catch (error) {
    yield put({
      type: FETCH_APPDATA_FAILED,
      message: error.message
    })
  }
}



export function* watchFetchAppData() {
  yield takeLatest(FETCH_APPDATA_REQUESTING, fetchAppData)
}